import { Auth } from '../firebase';
import { createUserWithEmailAndPassword,signInWithEmailAndPassword,signOut } from "firebase/auth";





export const createUser =({email,password})=> createUserWithEmailAndPassword(Auth, email, password)

export const sign_in_user =({email,password})=>signInWithEmailAndPassword(Auth, email, password)

export const sign_out = ()=>signOut(Auth)